import { get, isEmpty } from "lodash-es";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";
import { Company, Person } from "@mapmycustomers/shared/types/entity";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import { SHORT_ADDRESS } from "../../consts";
import { entityToAddressLines } from "../../formatters";

import Field, { FieldProperties } from "./Field";

const nestedAddressParser = (nestedAddressedEntityFields: string[]) => (entity: unknown) => {
  let address = "";
  nestedAddressedEntityFields.forEach((nestedAddressedEntityField) => {
    if (!address.length) {
      const nestedEntity: Company | Company[] | Person = get(entity, nestedAddressedEntityField);
      if (nestedEntity) {
        if (Array.isArray(nestedEntity)) {
          address = nestedEntity
            .map((entity) => {
              const { line1, line2, line3 } = entityToAddressLines(entity, SHORT_ADDRESS);
              return [line1, line2, line3].filter(isDefined).join(", ");
            })
            .filter((address) => !isEmpty(address))
            .join("; ");
        } else {
          const { line1, line2, line3 } = entityToAddressLines(nestedEntity, SHORT_ADDRESS);
          address = [line1, line2, line3].filter(isDefined).join(", ") || "";
        }
      }
    }
  });
  return address;
};

class NestedAddressField extends Field {
  constructor(data: Omit<FieldProperties, "type">, nestedAddressedEntityFields: string[]) {
    super({
      features: [
        FieldFeature.GEO_POINT_FIELD,
        FieldFeature.ADDRESS,
        FieldFeature.NON_IMPORT,
        FieldFeature.NON_INTEGRATION,
        FieldFeature.NON_ADDABLE_FORM_FIELD,
      ],
      type: FieldType.STRING,
      valueGetter: nestedAddressParser(nestedAddressedEntityFields),
      ...data,
    });
  }
}

export default NestedAddressField;
